import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {RECORDS_ROUTES} from '../../constants'
import {BiSolidBox} from 'react-icons/bi'

function RecordsMobileMenuLink() {
  return (
    <MobileMenuLink to={RECORDS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={BiSolidBox} />
        <span>Records</span>
      </div>
    </MobileMenuLink>
  )
}

export {RecordsMobileMenuLink}
